import { routes } from "./routes";
import { StrictMode } from "react";
import { AuthProvider } from "./context/auth";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { type Container, type RootOptions, createRoot } from "react-dom/client";

import "./styles/globals.css";

const router = createBrowserRouter(routes(), {
  basename: "/",
  future: {},
});

const rootOptions: RootOptions = {
  onRecoverableError(error, errorInfo) {
    console.error(error);
    console.error(errorInfo);
  },
};

const rootElement = document.getElementById("root") as Container;

createRoot(rootElement, rootOptions).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>
);
